import Container from "@components/Atomic/Container/Container";
import { Image } from "@components/Image/Image";
import ImageContent from "@components/ImageContent";
import { StyledContainer } from "@components/Styled/Container";
import React from "react";
import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import { withFeaturedImageContent } from "./withFeaturedImageContent";

import { clsx } from "clsx";

import Swiper from "@components/Swiper/Swiper";

SwiperCore.use([Pagination]);

const Wrapper = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(props.className, "relative mx-auto max-w-[1440px]")}
  />
);

const ContentWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "flex h-full items-center bg-white py-mini",
    )}
  />
);

const Content = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "mx-auto max-w-[500px] px-mini py-maxi [&_.rte_h1]:text-center [&_.rte_h1]:md:text-left [&_.rte_h2]:text-center [&_.rte_h2]:md:text-left [&_.rte_h3]:text-center [&_.rte_h3]:md:text-left [&_.rte_h4]:text-center [&_.rte_h4]:md:text-left [&_.rte_h5]:text-center [&_.rte_h5]:md:text-left [&_.rte_h6]:text-center [&_.rte_h6]:md:text-left [&_.rte_p]:text-center [&_.rte_p]:opacity-70 [&_.rte_p]:md:text-left",
    )}
  />
);

const Logo = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "absolute bottom-1/2 right-1/2 z-10 hidden w-full max-w-[272px] translate-x-1/2 translate-y-1/2 transform md:block",
    )}
  />
);

const FeaturedImageContent = withFeaturedImageContent(
  ({ sections, logo, onClickImage, styles, background = "light" }) => (
    <Container
      styles={styles}
      legacy={!styles?.length}
      background={background}
      data-component-type="section-featured-image-content"
    >
      {sections && (
        <Wrapper>
          <Logo>
            <Image image={logo.src} alt={logo.alt} ratio="1/1" />
          </Logo>
          {sections?.map((section) => (
            <ImageContent
              key={section?.image?.asset?.id}
              image={section?.image}
              imageLink={section?.imageLink}
              onClickImage={onClickImage}
              reverse={section?.reverse}
            >
              {section?.contents && (
                <ContentWrapper>
                  {section?.contents?.length > 1 ? (
                    <Swiper
                      observer={true}
                      observeParents={true}
                      spaceBetween={0}
                      slidesPerView={1}
                      pagination={{ clickable: true }}
                      lazy={true}
                      preloadImages={false}
                    >
                      {section?.contents.map((content, index) => (
                        <SwiperSlide
                          key={`image-content-swiper-slide-${index}`}
                        >
                          <Content data-testid="content">{content}</Content>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <Content data-testid="section-content">
                      {section?.contents[0]}
                    </Content>
                  )}
                </ContentWrapper>
              )}
            </ImageContent>
          ))}
        </Wrapper>
      )}
    </Container>
  ),
);

export default FeaturedImageContent;
